// Application types
export const LOADING_AUTHE = "LOADING_AUTHE";
export const LOGIN_ADMIN_USER = "LOGIN_ADMIN_USER";
export const LOGOUT_ADMIN_USER = "LOGOUT_ADMIN_USER";
export const LOADING_ADMIN = "LOADING_ADMIN";
export const LOADING_ADMIN_USER = "LOADING_ADMIN_USER";
export const LOADING_UPDATE_ADMIN_USER = "LOADING_UPDATE_ADMIN_USER";
export const LOADING_UPDATE_ADMIN = "LOADING_UPDATE_ADMIN";
export const LOADING_ADMIN_ERROR = "LOADING_ADMIN_ERROR";
